export const dashboardTours = {
  'dashboard-overview': {
    id: 'dashboard-overview',
    title: 'Your Dashboard',
    category: 'dashboard',
    steps: [
      {
        target: '.dashboard-tabs',
        content: 'Switch between your assignments and classes using these tabs.',
        placement: 'bottom'
      },
      {
        target: '.statistics-cards',
        content: 'Get a quick overview of your progress and statistics.',
        placement: 'bottom'
      },
      {
        target: '.notifications-dropdown',
        content: 'Stay updated with real-time notifications about your work.',
        placement: 'bottom-start'
      },
      {
        target: '.enhanced-table',
        content: 'Your data is displayed in this interactive table with sorting and filtering.',
        placement: 'top'
      },
      {
        target: '.profile-menu',
        content: 'Access your profile settings and account options here.',
        placement: 'bottom-start'
      }
    ],
    conditions: {
      userRole: 'any',
      firstVisit: true,
      delay: 1000
    }
  },

  'table-interactions': {
    id: 'table-interactions',
    title: 'Table Features',
    category: 'dashboard',
    steps: [
      {
        target: '.table-header th:first-child',
        content: 'Click any column header to sort your data ascending or descending.',
        placement: 'bottom'
      },
      {
        target: '.table-search',
        content: 'Search across all columns instantly with this search box.',
        placement: 'bottom'
      },
      {
        target: '.table-row:first-child',
        content: 'Click any row to view detailed information or edit the item.',
        placement: 'top'
      },
      {
        target: '.pagination-controls',
        content: 'Navigate through multiple pages of data using these controls.',
        placement: 'top'
      },
      {
        target: '.table-actions',
        content: 'Access quick actions like edit, delete, or view for each item.',
        placement: 'left'
      }
    ],
    conditions: {
      elementVisible: '.enhanced-table',
      delay: 500
    }
  },

  'client-dashboard': {
    id: 'client-dashboard',
    title: 'Client Dashboard Guide',
    category: 'client',
    steps: [
      {
        target: '.dashboard-tabs',
        content: 'Switch between your assignments and classes.',
        placement: 'bottom'
      },
      {
        target: '.statistics-cards',
        content: 'Track your progress with these visual statistics.',
        placement: 'bottom'
      },
      {
        target: '.discord-connector',
        content: 'Connect your Discord account for enhanced collaboration.',
        placement: 'top'
      },
      {
        target: '.assignments-table',
        content: 'View and manage all your assignments here.',
        placement: 'top'
      },
      {
        target: '.classes-table',
        content: 'Keep track of your classes and schedules.',
        placement: 'top'
      }
    ],
    conditions: {
      userRole: 'client',
      firstVisit: true,
      path: '/client/dashboard'
    }
  },

  'notifications-system': {
    id: 'notifications-system',
    title: 'Notifications',
    category: 'dashboard',
    steps: [
      {
        target: '.notification-bell',
        content: 'Click here to view your notifications.',
        placement: 'bottom'
      },
      {
        target: '.notification-item:first-child',
        content: 'Each notification shows important updates about your work.',
        placement: 'left'
      },
      {
        target: '.mark-all-read',
        content: 'Mark all notifications as read with this button.',
        placement: 'bottom'
      },
      {
        target: '.notification-settings',
        content: 'Customize your notification preferences.',
        placement: 'bottom'
      }
    ],
    conditions: {
      elementVisible: '.notification-dropdown',
      delay: 500
    }
  }
};